import * as React from "react";
import {
  SimpleForm,
  TextInput,
  Create,
  CreateProps,
  email,
  required,
  useNotify,
} from "react-admin";

export const CreateAdmin: React.FC<CreateProps> = (props) => {
  const notify = useNotify();
  return (
    <Create
      {...props}
      mutationOptions={{
        onSuccess: () =>
          notify("Se creó el usuario y se envió un correo de confirmación"),
      }}
    >
      <SimpleForm>
        <TextInput
          source="email"
          fullWidth
          required
          label="Email"
          validate={email()}
        />
        <TextInput
          source="fullName"
          fullWidth
          label="Nombre completo"
          validate={required()}
        />
      </SimpleForm>
    </Create>
  );
};
